import React, { useEffect } from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useCheckFlag } from 'hooks/useCheckFlag';
import { not } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Skeleton } from '@mui/material';

import { ControlledSelect } from 'components/shared';
import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { useGetDisconnectReasonOptions } from './hooks/useGetDisconnectReasonOptions';

export const UnlinkAutomaticallySection: React.FC = () => {
  const { t } = useTranslation();
  const getDisconnectReasonOptions = useGetDisconnectReasonOptions();

  const { control, setValue, watch } = useFormContext();
  const flags = watch('flags');
  const isReqDisconnectAutoFlagContained = useCheckFlag<DutyHourTypeDynFlag>(
    'flags',
    'REQ_DISCONNECT_AUTO'
  );

  useEffect(() => {
    if (not(isReqDisconnectAutoFlagContained)) {
      setValue(
        'flags',
        flags.filter((item) => item !== 'REQUEST_DISCONNECT_CUST_ALTER')
      );
      setValue('reqDisconnectReasonAvId', '');
    }
  }, [isReqDisconnectAutoFlagContained]);

  return (
    <MultiStepForm.Section
      title={t('dutyHourTypes.section.unlinkAutomatically')}
    >
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        flag="REQ_DISCONNECT_AUTO"
        label={t('dutyHourTypes.fieldName.unlinkRequestAutomatically')}
        name="flags"
      />

      {isReqDisconnectAutoFlagContained &&
        (getDisconnectReasonOptions.isLoading ? (
          <Skeleton />
        ) : (
          <ControlledSelect
            control={control}
            label={t('dutyHourTypes.fieldName.reqDisconnectReasonSelect')}
            name="reqDisconnectReasonAvId"
            variant="outlined"
            options={
              isReqDisconnectAutoFlagContained
                ? getDisconnectReasonOptions.data ?? []
                : []
            }
          />
        ))}
    </MultiStepForm.Section>
  );
};
